import { Check } from 'lucide-react';
import type { PrayerStatus } from '../../types';

type Props = {
  target: number;
  done: number;
  status: PrayerStatus;
};

// Above this many units, discrete dots overflow the row — switch to a compact bar.
const DOT_MAX = 10;

export function ProgressTrack({ target, done, status }: Props) {
  if (status === 'skipped') {
    return <span className="text-[12px] text-ink-muted">o'tkazildi</span>;
  }

  const showCheck = status === 'done';

  if (target > DOT_MAX) {
    const frac = target > 0 ? Math.min(1, done / target) : 0;
    return (
      <div className="flex items-center gap-2">
        <div className="h-1.5 w-20 overflow-hidden rounded-full bg-ink-subtle/25">
          <div className="h-full rounded-full bg-child-accent" style={{ width: `${frac * 100}%` }} />
        </div>
        {showCheck ? <Check size={12} className="text-child-accent" /> : null}
      </div>
    );
  }

  const filled = Math.min(done, target);
  const empty = Math.max(0, target - done);
  const bonus = Math.max(0, done - target);

  return (
    <div className="flex items-center gap-[5px]">
      {Array.from({ length: filled }).map((_, i) => (
        <span
          key={`f${i}`}
          className="inline-block h-[7px] w-[7px] rounded-full bg-child-accent"
        />
      ))}
      {Array.from({ length: empty }).map((_, i) => (
        <span
          key={`e${i}`}
          className="inline-block h-[7px] w-[7px] rounded-full border border-ink-subtle/40"
        />
      ))}
      {bonus > 0 ? (
        <span className="ml-[5px] flex items-center gap-[3px]">
          {Array.from({ length: bonus }).map((_, i) => (
            <span
              key={`b${i}`}
              className="inline-block h-[5px] w-[5px] rounded-full bg-child-accent opacity-60"
            />
          ))}
        </span>
      ) : null}
      {showCheck ? <Check size={12} className="ml-[6px] text-child-accent" /> : null}
    </div>
  );
}
